export const ELEVAR_CUSTOMER_QUERY_KEY = 'elevar-customer';

// Viewport tracking configuration
export const ELEVAR_VIEWPORT_TRACKING = {
  BATCH_SIZE: 4,
  BATCH_DELAY: 500, // milliseconds
  ROOT_MARGIN: '100px',
  THRESHOLD: 0.1,
} as const;

// Event order management
export const ELEVAR_EVENT_ORDER = {
  // Events that require dl_user_data to fire first
  PROTECTED_EVENTS: [
    'dl_view_cart',
    'dl_purchase',
    'dl_view_search_results',
    'dl_begin_checkout',
    'dl_view_item',
    'dl_view_item_list',
  ] as const,
  // Maximum time since last dl_user_data before we need to send a new one
  USER_DATA_MAX_AGE: 5000, // 5 seconds
  // Minimum delay after dl_user_data before protected events can fire
  USER_DATA_DELAY: 100, // milliseconds
} as const;
